import axios from 'axios';
import { getAccessToken, getTokenExchangePromise, isLogoutPage, login } from './oauth2Service.js';

/**
 * Sets up Axios interceptors for Bearer token authentication.
 *
 * This interceptor:
 * 1. Attaches Authorization: Bearer <token> to all requests
 * 2. On 401 responses, waits for any in-progress token exchange before redirecting to login
 */
export const setupAxiosAuthInterceptor = () => {
  // Request interceptor - attach Bearer token
  axios.interceptors.request.use(
    (config) => {
      const token = getAccessToken();
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    },
    (error) => Promise.reject(error)
  );

  // Response interceptor - handle 401
  axios.interceptors.response.use(
    (response) => response,
    async (error) => {
      if (error.response?.status === 401) {
        // If a token exchange is in progress, wait for it instead of redirecting immediately
        const exchangePromise = getTokenExchangePromise();
        if (exchangePromise) {
          console.warn('[Auth] Received 401 - token exchange in progress, waiting...');
          await exchangePromise;
          return Promise.reject(error);
        }
        if (!isLogoutPage()) {
          console.warn('[Auth] Received 401 - redirecting to login');
          sessionStorage.removeItem('access_token');
          login();
        }
      }
      return Promise.reject(error);
    }
  );
};
